import { createSelector } from 'reselect';

const selectLMSChapters = (state: any) => state.lmsChapters;

export const selectLMSChaptersCurrentItem = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.current);

export const selectLMSChaptersListItems = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.list);

export const selectLMSChaptersItemById = (itemId: any) =>
    createSelector(selectLMSChaptersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLMSChaptersQueryItems = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.query);

export const selectLMSChaptersCreatedItem = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.create);

export const selectLMSChaptersUpdatedItem = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.update);

export const selectLMSChaptersReadItem = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.read);

export const selectLMSChaptersDeletedItem = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.delete);

export const selectLMSChaptersSearchedItems = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.search);

export const selectLMSChaptersItemsCount = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.count);

export const selectLMSChaptersItemsFilter = createSelector([selectLMSChapters], (lmsChapters) => lmsChapters.filter);
